import type { H2State } from "../schema/scenario";

/*
 * 경로 조합 , 사용자는 "어떤 수소인가" 부터 정한다: 생산방식 → 전력원 → 저장,이송 경로 → 산정방식.
 * 조합을 고르면 아래 설비 사슬이 채워진 시나리오가 만들어진다. 예시도 같은 조합으로 만든다(값을 두 곳에 두지 않는다).
 */

/** 생산방식별 생산시설 내부 설비 사슬(템플릿 id, 공정 순서) */
export const PRODUCTION_CHAINS: Record<string, string[]> = {
  aec: ["aec.water_purifier", "aec.stack", "aec.purifier", "aec.aux"],
  pem: ["pem.water_purifier", "pem.stack", "pem.purifier", "pem.aux"],
  smr: ["smr.ng_supply", "smr.reformer", "smr.psa", "smr.aux"],
  byproduct: ["byproduct.source", "byproduct.psa", "byproduct.aux"],
};

export interface Route {
  id: string;
  name: string;
  description: string;
  /** 생산 사슬 뒤에 붙는 저장,이송 설비 */
  templateIds: string[];
  /** 이 경로의 기본 인도 조건 */
  fu: { pressureBar: number; state: H2State; deliveryPoint: string };
  order: number;
}

export const ROUTES: Route[] = [
  { id: "gate", name: "출하까지", description: "생산시설 내부만, 출하 압축(200 bar)까지. 저장 및 이송은 없음", templateIds: ["common.compressor_gate"], fu: { pressureBar: 200, state: "gas", deliveryPoint: "생산시설 출하지점" }, order: 1 },
  { id: "compressed_trailer", name: "압축 + 튜브트레일러", description: "200 bar 압축, 200 km 도로 운송, 충전소 재압축,고압 저장", templateIds: ["common.compressor_gate", "transport.tube_trailer", "storage.station_compressor", "storage.hp_tank"], fu: { pressureBar: 450, state: "gas", deliveryPoint: "수소충전소 저장탱크 입고" }, order: 2 },
  { id: "liquid_tanker", name: "액화 + 탱크로리", description: "액화(약 10 kWh/kg), 200 km 탱크로리, 액화저장", templateIds: ["storage.liquefier", "transport.liquid_tanker", "storage.lh2_tank"], fu: { pressureBar: 1, state: "liquid", deliveryPoint: "수요처 액화저장탱크 입고" }, order: 3 },
  { id: "pipeline", name: "파이프라인", description: "완충 저장 후 50 km 배관 수송", templateIds: ["common.buffer_tank", "transport.pipeline"], fu: { pressureBar: 30, state: "gas", deliveryPoint: "수요처 배관 인도지점" }, order: 4 },
];

export interface ElectricityPreset {
  id: string;
  label: string;
  description: string;
  sources: { sourceId: string; share: number }[];
}

/** 전력원 빠른 선택 , 세부 비율은 산정 화면 운전자료 단계에서 바꾼다 */
export const ELECTRICITY_PRESETS: ElectricityPreset[] = [
  { id: "grid", label: "계통전력 100%", description: "국가 전력배출계수 적용", sources: [{ sourceId: "grid_kr", share: 1 }] },
  { id: "renewable", label: "재생에너지 100%", description: "단순화 계수 0 적용", sources: [{ sourceId: "solar", share: 1 }] },
  { id: "mix50", label: "계통·재생 혼합", description: "비율은 ‘운전자료 입력’에서 조정", sources: [{ sourceId: "grid_kr", share: 0.5 }, { sourceId: "solar", share: 0.5 }] },
];

/** 전력을 쓰는 생산방식(전력원 선택이 뜻이 있는 것) */
export const ELECTRICITY_DRIVEN_TECHS = new Set(["aec", "pem"]);
